import React from 'react';
import {useDispatch,} from "react-redux";
import {stepStates} from '../../../services/helpers';
import {assetsBaseUrl} from "../../../services/calculationsApi";
import {useMediaQuery} from "@react-hook/media-query";
import {mainMediaMobile} from "../../../services/helpers";
import {setField} from "../../../store/actions/calculatorActions";

export const stepTitles = [
    'Bruto jaarinkomen',
    "Kredieten en leningen",
    "Woning",
    "Inleg eigen geld",
    'Hypotheekvorm'
];

function StepHeader({title, stepNumber, stepState, openStep, stepSummary, onClose}) {
    let backLink;
    const dispatch = useDispatch();
    const mediaMatches = useMediaQuery(mainMediaMobile);

    const openPrevStep = () => {
        dispatch(setField('lastActiveStepIndex', stepNumber - 1));

        openStep(stepNumber, false, true);
    };

    if (mediaMatches) {
        if (stepNumber === 0) {
            backLink = (
                <a href={document.referrer} className="ct_back-button-mobile">
                    <img src={`${assetsBaseUrl}/assets/svg/arrow-down-secondary.svg`} alt=""/>Terug
                </a>
            );
        } else {
            backLink = (
                <button href={void(0)} className="ct_back-button-mobile ct_back-button-mobile--button" onClick={openPrevStep}>
                    <img src={`${assetsBaseUrl}/assets/svg/arrow-down-secondary.svg`} alt=""/>{stepTitles[stepNumber - 1]}
                </button>
            )
        }
    }

    const toggleStep = () => {
      if (stepState !== stepStates.inactive && !mediaMatches) {
        openStep(stepNumber);
      }
      if (stepState === stepStates.active && stepStates.filled && onClose) {
        onClose();
      }
    };

    return (
        <div className="ct-step__header" onClick={() => toggleStep()}>
            <div className="ct-step__header-left">
                {stepState === stepStates.filled && (
                    <div className="ct-step__header-left-icon">
                        <img src={`${assetsBaseUrl}/assets/svg/check.svg`} alt=""/>
                    </div>
                )}

                <div className={
                    `ct-step__header-left-title ${(stepState === stepStates.inactive
                        || stepState === stepStates.filled) ? "ct-step__header-left-title-inactive" : null}`}
                >
                    {backLink}

                    <div>
                        {title}
                    </div>
                </div>
            </div>

            {stepState !== stepStates.inactive ?
                <div className="ct-step__header-right">
                    <div>
                        {stepSummary}
                    </div>

                    {(stepState === stepStates.filled || stepState === stepStates.closed) ? (
                        <div className="ct-step__header-open-button">
                            <img src={`${assetsBaseUrl}/assets/svg/arrow.svg`} alt=""/>
                        </div>
                    ) : (
                        <div className="ct-step__header-close-button">
                            &ndash;
                        </div>
                    )}
                </div>
                : null}
        </div>
    );
}

export default StepHeader;
